// When the deal header offers "Propose Decline". Mirrors the server
// (DealDeclineService.ProposeDeclineAsync): the caller holds
// DealFlow.ProposeDecline, no decline is proposed or ratified yet, and the deal
// is not Closed or Withdrawn (owner approval, 2026-10-13; Confirm refuses those
// too). A deal at stage Declined still takes a proposal: that ratifies a stage
// decline.

import type { DealPipelineStage } from "@/types/deals";

export function canProposeDecline(options: {
  stage: DealPipelineStage;
  declineStatus: string;
  hasProposePermission: boolean;
}): boolean {
  return (
    options.hasProposePermission &&
    options.declineStatus === "Active" &&
    options.stage !== "Closed" &&
    options.stage !== "Withdrawn"
  );
}
